<template>
  <div ref='table'>
    <teamRankCell v-for="item in ranks" :key='item.type' :rankData="item"/>
    <loadStateView :state='netState' :refreshHandle="loadData"/>
  </div>
</template>>

<script>
import teamRankCell from './components/teamRankCell'
import { checkEmptyObject } from '@/utils'

export default {
  name: 'league-rank',
  props: {
    leagueId: {
      type: String,
      required: true
    }
  },
  components: {
    teamRankCell
  },
  data () {
    return {
      ranks: []
    }
  },
  activated () {
    this.loadData()
  },
  watch: {
    leagueId (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadData()
      }
    }
  },
  methods: {
    loadData () {
      this.netState = checkEmptyObject(this.ranks) ? 1 : 0
      this.$dataBaseClient.get(`b_league/leagueRank?leagueId=${this.leagueId}`)
        .then((response) => {
          this.netState = response.netState

          if (this.netState === 3) {
            this.ranks = []
            return
          }

          this.ranks = [
            {
              type: 0,
              list: response.rank
            },
            {
              type: 1,
              list: response.eastRank
            },
            {
              type: 2,
              list: response.westRank
            }
          ]
          console.log(response)
        })
        .catch((error) => {
          this.netState = 2
          console.log(error)
        })
    }
  }
}
</script>

<style lang="sass" scoped>

</style>
